import type { StepMap } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { NativeAppDownloadStep } from "./native-app-download-step";

export const NativeAppDownloadStepMap: StepMap = {
  "native-app-download": {
    id: "native-app-download",
    group: "native-app-upsell",
    render: props => <NativeAppDownloadStep {...props} />,
  },
} as const;
